import { render, staticRenderFns } from "./homeDashboardLeadStatistics.vue?vue&type=template&id=23c5e86b&scoped=true"
import script from "./homeDashboardLeadStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardLeadStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardLeadStatistics.vue?vue&type=style&index=0&id=23c5e86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5e86b",
  null
  
)

export default component.exports